import React, { useContext } from 'react';

import debounce from 'lodash/debounce';
import { useFormContext } from 'react-hook-form';

import { OnboardingStepTitle } from '@vyce/core/src/components/OnboardingStepTitle';
import { ControlledAutocomplete } from '@vyce/core/src/components/controlled-inputs/ControlledAutocomplete';

import { ManualClockContext } from './ManualClockProvider';
import { ALL_CLOCKED_IN_OPTION } from '../config/constants';

const rules = {
  required: 'Name is required',
};
const name = 'selectedWorker';

export const WorkerStep = () => {
  const { workers, action, canBulkClockOut, nextStep } = useContext(ManualClockContext);
  const { watch } = useFormContext();

  const selectedWorker = watch(name);

  const workerOptions = workers?.map(item => ({ name: `${item.first_name} ${item.last_name}`, id: item.user_id }));
  // Clocking everyone out only makes sense from the clock-out list, and the
  // preview needs the checked-in list, so the option follows both.
  const options =
    action === 'out' && canBulkClockOut ? [ALL_CLOCKED_IN_OPTION, ...(workerOptions ?? [])] : workerOptions;
  const handleChange = (value: string) => {
    if (!selectedWorker) {
      nextStep(action === 'in' ? 3 : 2);
    }
  };
  return (
    <>
      <OnboardingStepTitle text={`Who do you want to manually clock ${action}?`} />

      <ControlledAutocomplete
        name={name}
        label="Select name"
        rules={rules}
        margin="normal"
        items={options}
        onChange={debounce(handleChange, 500)}
      />
    </>
  );
};
